import React from 'react'

const ViewCounselling = () => {
  return (
    <div>ViewCounselling</div>
  )
}

export default ViewCounselling